var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-center full-width"},[_c('div',{staticClass:"desktop-single-column row items-center full-width"},[_c('div',{staticClass:"q-px-md q-py-xl full-width"},[_c('div',{staticClass:"thank-you-card bdr-a-grey-3 bg-white row justify-center q-py-xl q-px-md"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }